import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "cursor-pointer symbol symbol-30px symbol-md-40px",
        style: {"padding-right":"10px"},
        "data-kt-menu-trigger": "click",
        "data-kt-menu-attach": "parent",
        "data-kt-menu-placement": "bottom-end",
        "data-kt-menu-flip": "bottom"
      }, [
        _createElementVNode("img", {
          src: "/media/avatars/blank.png",
          alt: "metronic"
        })
      ], -1)),
      _createVNode(_component_KTUserMenu)
    ])
  ]))
}